import {
  PRODUCTTYPE_LOADING,
  GET_PRODUCTTYPE,
  GET_PRODUCTTYPE_SUCCESS,
  GET_PRODUCTTYPE_FAIL,
  ADD_PRODUCTTYPE_SUCCESS,
  ADD_PRODUCTTYPE_FAIL,
  DELETE_PRODUCTTYPE_SUCCESS,
  DELETE_PRODUCTTYPE_FAIL,
  UPDATE_PRODUCTTYPE_SUCCESS,
  UPDATE_PRODUCTTYPE_FAIL,
  PRODUCTTYPE_RESET,
} from "./actionType";

const INIT_STATE = {
  productTypes: [],
  error: {},
};

const ProductType = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTTYPE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTTYPE:
          return {
            ...state,
            productTypes: action.payload.data,
            isProductTypeCreated: false,
            isProductTypeSuccess: true,
            loading: false,
          };
        default:
          return { ...state };
      }
    case GET_PRODUCTTYPE_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTTYPE_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductTypeCreated: false,
            isProductTypeSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTTYPE: {
      return {
        ...state,
        isProductTypeCreated: false,
        loading: true,
      };
    }

    case PRODUCTTYPE_LOADING: {
      return {
        ...state,
        isProductTypeCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTTYPE_SUCCESS:
      return {
        ...state,
        isProductTypeCreated: true,
        loading: false,
        productTypes: [action.payload.data, ...state.productTypes],
      };

    case ADD_PRODUCTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        productTypes: state.productTypes.filter(
          (productType) =>
            productType.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTTYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        productTypes: state.productTypes.map((productType) =>
          productType.id.toString() === action.payload.data.id.toString()
            ? { ...productType, ...action.payload.data }
            : productType
        ),
      };

    case UPDATE_PRODUCTTYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTTYPE_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductType;
